import { useMediaQuery } from '@/hooks/useMediaQuery';

import CompleteProfileModalDesktop from './CompleteProfileModalDesktop';
import CompleteProfileModalMobile from './CompleteProfileModalMobile';

const CompleteProfileModal = () => {
  const isDesktop = useMediaQuery('(min-width: 768px)');

  if (isDesktop) {
    return <CompleteProfileModalDesktop />;
  }

  return <CompleteProfileModalMobile />;
};

export default CompleteProfileModal;
